var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCategoryDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 50 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Category",
    transform: "translate(-331.283 -201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 50,
    height: 30,
    rx: 4,
    transform: "translate(331.283 201)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7881",
    "data-name": "Group 7881",
    transform: "translate(-0.717)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Done",
    transform: "translate(342 220)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Done"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCategoryDone);
export default __webpack_public_path__ + "static/media/Edit_Category_Done.e1e9fa07.svg";
export { ForwardRef as ReactComponent };